import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { AuditFaultTypeModel } from '@/libs/Api';
import { AuditFaultTypesDataService } from '@/libs/audit-fault-types/audit-fault-types-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const auditFaultTypesStore = registerCrudStore<AuditFaultTypeModel, AuditFaultTypeModel>(
    BusinessModule.AuditFaultType,
    new AuditFaultTypesDataService()
);
